import { inject } from '@angular/core';
import {
  Router,
  CanActivateFn,
} from '@angular/router';
import {  of, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../api/services/utility-services/common.service';
import { RoleConstants } from '../constants/role.constants';


export type GuardType = "session" | "partner" | "customer" | "customerSuperUser";
export const authGuardNew = (guardType: GuardType): CanActivateFn => {
  return (route, state) => {

    const commonService = inject(CommonService);

    const router = inject(Router);
      return commonService.session().pipe(switchMap(session => {
        const validlogin =!!(session && session.sessionId && session.userName)
        if(validlogin && guardType==="session") {
          return of(true);
        }
        if(validlogin && guardType==="partner"){
          return of (session.userRoles.includes(RoleConstants.PARTNER))
        }
        if(validlogin && guardType==="customer"){
          return of (session.userRoles.includes(RoleConstants.CUSTOMER))
        }
        if(validlogin && guardType==="customerSuperUser"){
          return of (session.userRoles.includes(RoleConstants.CUSTOMER_SUPER_USER))
        }
        else{
          if(guardType==="session"){
            return of(true);
          }
          router.navigate(['/login']);
          return of(false);
        }
      }
    ))
  }
}
